import type { CanDeactivateFn } from '@angular/router';
import type { LicenseUtilizationConfig } from './license-utilization-config';

const LEAVE_PROMPT = 'You have unsaved changes to the utilization rules. Leave without saving?';

export const licenseUtilizationConfigGuard: CanDeactivateFn<LicenseUtilizationConfig> = (component) =>
  !component.hasUnsavedChanges() || window.confirm(LEAVE_PROMPT);
